/*

ashraf 10/07/2022  2700799562 fixed dropdown values, pagination
sohel 10/14/2022 2700799562  Global Field -> Added Code Comments Changes
sohel 10/14/2022 2700799562  Global Field -> Added Code Comments
suresh 10/17/2022 2700799562 Design Enhancements in global Field Group, List.
Ashraf 10/30/2022 2700799562 fixed table pagination issue
saikrishna 11/03/2022 2700799562 changed the paginationOptions
Lalitha 11/10/2022 2700799562 Added title Created by in table and arrange table
Ashraf 11/15/2022 2700799562 disabling save button based on role access
Raghu 11/28/2022 2700799562 Table Footer Fixes
Rajesh 12/08/2022 2700799562  removed fieldlist column ,sort payload and alignment issues
Akhila 12/09/2022 2700799562 Added form Notes
Ashraf 12/09/2022 2700799562 fixed reset notes issue
Ashraf 12/14/2022 2700799562 fixed role access
Lalitha 12/15/2022 2700799562 Added Role Base Access
Ashraf 12/19/2022 2700799562 fixed notes search page break
kavyareddy 12/20/2022 2700799562 changed dropdown for createdBy and noteType payload
Raghu 12/26/2022 2700799562 Added class for system notes popup styles
Ashraf 01/12/2022 2700799562 conditional payload renders for audit list
suresh peddavoora 02/24/2023 2700799562 New UI changes
Akhila 06/07/2023 2700799562 added code and description in action
Akhila 07/01/2023 2700799562 field list name change to audit field list
Dilip-pds 10/19/2023 2700799562 fixed created by dropdown issue
Gireesh 18-1-2023 2700799562 updated payload 
*/

import React, {createRef, useState, useEffect} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../../components/DialogBox';
import {
  postSystemNotes,
  ResetMessage as resetMessage,
} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import {ErrorSnackbar, SuccessSnackbar} from './../../../../../components/CustomSnackBar/index';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import SearchNotesForm from '../../../../../components/SearchNotes/searchNotesForm';

export default function GlobalFieldListSystemNotes({filedListCode, AuditFieldList}) {
  const moment = require('moment-timezone');
  const columns = [
    // {
    //   title: "Field List Code",
    //   field: "filterCode",
    //   render: (rowData) => <>{rowData?.code}</>,
    // },
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created by',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];

  const {roleData} = useSelector(({role}) => role);
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  let transcription = '';
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  // const roleAccess = !roleData?.window?.["Field List"]?.["FL"]?.add;
  const disable = roleData?.window?.['Audit Field List']?.['FL'];
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  const {isSystemNoteLoading, systemNotesStatus, notesuccessMsg, errorMsg} = useSelector(
    ({addFieldList}) => addFieldList,
  );

  // User Defined notes successfully add then after 3 sec update system notes data and reset Data (2700799562)
  useEffect(() => {
    if (systemNotesStatus === 200) {
      tableRef.current.onQueryChange();
      handleDialogClose();
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [systemNotesStatus]);

  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);
  // add User Defined notes(2700799562)
  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        postSystemNotes({
          code: filedListCode ? filedListCode?.fieldListCode : '',
          noteText: data,
          frameworkType: AuditFieldList ? 'AUDIT_FIELD_LIST' : '',
          reportId: filedListCode?.fieldListId ? filedListCode?.fieldListId: 0,
        }),
      );
    }
  };

  // User Defined notes reset Toast message after 2.5sec(2700799562)
  useEffect(() => {
    if (errorMsg || notesuccessMsg) {
      setTimeout(() => {
        resetMessage();
      }, 2500);
    }
  }, [errorMsg, notesuccessMsg]);
  return (
    // Changed Colors for Table header and body (2700799562)
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={isSystemNoteLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            disableByRoleAccess={'enable'}
          />
        )}
      </DialogBox>
      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          AuditFieldListCode={filedListCode}
          moduleName={'auditfieldlist'}
        />
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `globalfield/find/all/fieldlistnotes`;
                const bodyObj = {
                  code: filedListCode?.fieldListCode,
                  frameworkId: filedListCode?.fieldListId ? filedListCode?.fieldListId: 0,
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection,
                  search: '',
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  frameworkType: AuditFieldList ? 'AUDIT_FIELD_LIST' : '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!filedListCode?.fieldListCode) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    <Button variant="outlined" className="search-btn" disabled={!disable?.add}>
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                // disabled: roleAccess,
                disabled: !disable?.add,
                isFreeAction: true,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {notesuccessMsg && <SuccessSnackbar successMsg={notesuccessMsg} />}
    </>
  );
}
